import React, { useEffect, useState } from "react";
import "../../../admin_resources/css/admin_layout.css";
import "../../../admin_resources/css/admin_common.css";
import "../../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "../Admin_Header";
import ADMIN_FOOTER from "../Admin_Footer";
import axios from "axios";
import xlsx from "../../../resources/images/common/excel_icon.png";

const Admin_Point = () => {
  const [raonMembers, setRaonMembers] = useState([]);
  const [selectAll, setSelectAll] = useState(false); // 전체 체크 상태
  const [checkedItems, setCheckedItems] = useState({}); // 개별 체크 상태

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 관리자 페이지`;

    const fetchRaonMembers = async () => {
      try {
        const response = await axios.get("/raonmember"); // API 호출
        const data = response.data;

        // 체크박스 초기화
        const initialCheckedItems = {};
        data.forEach((member) => {
          initialCheckedItems[member.idx] = false; // 초기값 false
        });

        setRaonMembers(data);
        setCheckedItems(initialCheckedItems);
      } catch (err) {
        console.error("데이터 불러오기 실패:", err);
      }
    };

    fetchRaonMembers();
  }, []); // 빈 배열로 초기 한 번만 호출

  // 전체 선택/해제
  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    // 모든 항목의 체크 상태를 업데이트
    const updatedCheckedItems = {};
    raonMembers.forEach((member) => {
      updatedCheckedItems[member.idx] = newSelectAll;
    });

    setCheckedItems((prevState) => ({
      ...prevState,
      ...updatedCheckedItems,
    }));
  };

  // 개별 체크박스 상태 변경
  const handleCheckboxChange = (id) => {
    setCheckedItems((prevState) => ({
      ...prevState,
      [id]: !prevState[id], // 선택 상태 토글
    }));
  };

  const handleSettlePoints = async () => {
    // 체크된 idx만 가져옴
    const selectedIds = Object.keys(checkedItems)
      .filter((key) => checkedItems[key])
      .map(Number); // 숫자로 변환

    console.log("Selected IDs:", selectedIds); // 이제 숫자 배열로 출력됩니다.

    if (selectedIds.length === 0) {
      alert("선택된 항목이 없습니다.");
      return;
    }

    if (window.confirm("정말로 선택한 회원들의 적립금을 정산하시겠습니까?")) {
      try {
        const response = await axios.post("/settle", selectedIds);

        if (response.status === 200) {
          alert("정산이 완료되었습니다.");
          // window.location.reload(); // 데이터 새로고침
        }
      } catch (error) {
        console.error("정산 중 오류 발생:", error);
        alert("정산 중 오류가 발생했습니다.");
      }
    }
  };

  const downloadExcel = async () => {
    try {
      const currentData = raonMembers; // 현재 화면의 데이터
      const response = await axios.post("/canclelistdownload", currentData, {
        responseType: "blob", // Excel 파일로 받기 위한 blob 설정
      });

      // 파일 다운로드 처리
      const disposition = response.headers["content-disposition"];
      const fileName = disposition
        ? decodeURIComponent(
            disposition.split("filename=")[1].replace(/"/g, "")
          )
        : "CurrentData.xlsx";

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    } catch (error) {
      console.error("Excel 파일 다운로드 실패:", error);
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="main_compo">
        <div className="path-sec">
          HOME &gt; <span className="menu1">데이터 관리</span> &gt;
          <span className="menu2"> 창업 일정 관리</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">데이터 관리</h3>
                <ul className="snb_list">
                  <li>
                    <a href="/admin/form/ent">입회신청 관리</a>
                  </li>
                  <li>
                    <a href="/admin/form/fr">창업신청 관리</a>
                  </li>
                  <li>
                    <a href="/admin/form/franchise">가맹점 관리</a>
                  </li>
                  <li>
                    <a href="/admin/form/schedule">창업일정 관리</a>
                  </li>
                  <li>
                    <a href="/admin/form/jisa">지사장 지원 관리</a>
                  </li>
                  <li>
                    <a href="/admin/form/q">앱 문의 관리</a>
                  </li>
                  <li>
                    <a href="/admin/form/etc_q">기타문의 관리</a>
                  </li>
                  {(localStorage.getItem("adminId") === "jiwoo" ||
                    localStorage.getItem("adminId") === "nixona" ||
                    localStorage.getItem("adminId") === "wjdrnr90" ||
                    localStorage.getItem("adminId") === "hyoseon.jang") && (
                    <li className="cur">
                      <a href="/admin/form/point">적립금 정산 관리</a>
                    </li>
                  )}
                </ul>
              </div>
            </td>
            <td className="right_m">
              <div className="sec-cont">
                <form name="delfrm">
                  <div className="tb_01">
                    <div className="bx_sch_btm bg_1">
                      <span
                        className="btn custom_s"
                        style={{ backgroundColor: "red", float: "left" }}
                      >
                        <button onClick={handleSettlePoints}>선택 정산</button>
                      </span>
                      <button onClick={downloadExcel}>
                        <img src={xlsx} width="25px" height="25px" alt="xlsx" />
                      </button>
                      &nbsp;&nbsp;
                      <span className="btn info">
                        <button
                          onClick={downloadExcel}
                          style={{
                            backgroundColor: "#2196f3",
                            color: "#fff",
                            fontWeight: "bold",
                          }}
                        >
                          전체 다운로드
                        </button>
                      </span>
                    </div>
                    <table>
                      <thead>
                        <tr>
                          <th>
                            {" "}
                            <input
                              type="checkbox"
                              checked={selectAll}
                              onChange={handleSelectAll} // 전체 선택 토글
                            />
                          </th>
                          <th>ID</th>
                          <th>이름</th>
                          <th>지사명</th>
                          <th>교육원명</th>
                          <th>연락처</th>
                          <th>가맹유형</th>
                          <th>오픈일</th>
                          <th>해지일</th>
                          <th>포인트</th>
                          <th>은행</th>
                          <th>계좌번호</th>
                          <th>예금주</th>
                        </tr>
                      </thead>
                      <tbody>
                        {raonMembers.map((member) => (
                          <tr key={member.idx}>
                            <td>
                              <input
                                type="checkbox"
                                checked={checkedItems[member.idx] || false} // 선택 상태
                                onChange={() =>
                                  handleCheckboxChange(member.idx)
                                } // 개별 선택 상태 변경
                              />
                            </td>
                            <td>{member.id}</td>
                            <td>{member.NAME}</td>
                            <td>{member.jisa_name}</td>
                            <td>{member.nickname}</td>
                            <td>{member.mobilephone}</td>
                            <td>
                              {member.franchisetype === "A"
                                ? "공부방형"
                                : member.franchisetype === "B"
                                ? "학원형"
                                : "샵인샵"}
                            </td>
                            <td>{member.open_date}</td>
                            <td style={{ color: "red" }}>
                              {member.contract_cancel}
                            </td>
                            <td>{member.POINT.toLocaleString()}</td>
                            <td>{member.bank_name}</td>
                            <td>{member.bank_no}</td>
                            <td>{member.bank_holder}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </form>
              </div>
            </td>
          </tr>
        </table>
      </div>
	  <ADMIN_FOOTER/>
    </div>
  );
};

export default Admin_Point;
